import { createFileRoute, Outlet } from '@tanstack/react-router';
import { adminGuard } from '@/lib/route-guards';

export const Route = createFileRoute('/admin/__root')({
  beforeLoad: adminGuard,
  component: () => <Outlet />,
});
